import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Appraisal1004p from "components/Homeowner/CaseForms/Appraisal1004P/Appraisal1004p";
import responseHandler from "responseHandler";

class DonTestPage extends Component {

  render() {
    return (<Appraisal1004p 
      controlNumber={"14080683"} 
      />);
  }
}


DonTestPage.propTypes = {
  makeToast: PropTypes.func.isRequired,
};


const mapDispatchToProps = dispatch => ({
  
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  }
});

export default connect (mapDispatchToProps) (DonTestPage);
